<!-- an hidden div is created to set the position of appearance of the menu-->
<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
  #menuTrigger
></div>

<div class="row">
  <div class="consulta-box" style="border-radius: 4px" *ngIf="showConsulta">
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu1"
      style="
        margin-right: -13px;
        position: relative;
        margin-left: auto;
        float: right;
      "
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu1="matMenu">
      <button mat-menu-item color="primary" (click)="importExcel()">
        Importar <mat-icon>insert_drive_file</mat-icon>
      </button>
      <button mat-menu-item color="primary" (click)="exportGraph()">
        Exportar <mat-icon>file_copy</mat-icon>
      </button>
    </mat-menu>
    <div class="row">
      <mat-tab-group>
        <mat-tab label="Consulta" mat-align-tabs="center">
          <div class="mt-3 consulta" class="node-list-container">
            <div style="text-align: left !important">
              <button
                mat-button
                color="primary"
                (click)="rehacer()"
                style="margin-left: 9%"
              >
                <mat-icon>undo</mat-icon>
                Rehacer
              </button>
            </div>

            <mat-form-field
              class="example-full-width inputCI"
              appearance="outline"
              style="width: 83%"
            >
              <input
                matInput
                type="text"
                [(ngModel)]="consulta"
                (ngModelChange)="onInputChange($event)"
                placeholder="Consulta"
              />
              <mat-icon matPrefix class="my-icon">search</mat-icon>
            </mat-form-field>

            <mat-accordion>
              <mat-expansion-panel
                hideToggle
                *ngFor="let nodes of nodeListDefault | keyvalue"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon
                      >person
                      <mat-badge
                        matBadgeOverlap="false"
                        matBadgePosition="above after"
                        class="number-icon"
                        [matBadge]="nodes.value.length"
                      ></mat-badge>
                    </mat-icon>
                    <span style="margin-left: 15px">{{ nodes.key }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list role="list" class="mat-list-item-nodes">
                  <mat-list-item
                    role="listitem"
                    *ngFor="let node of nodes.value"
                    class="node"
                  >
                    <mat-checkbox
                      class="example-margin"
                      [(ngModel)]="node.checked"
                      (ngModelChange)="changeNodeCheck(node)"
                      [labelPosition]="'after'"
                      color="primary"
                    >
                      {{ node.titulo }}
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                </mat-list>
              </mat-expansion-panel>

              <mat-expansion-panel hideToggle *ngIf="client_count !== 0">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon
                      >person
                      <mat-badge
                        matBadgeOverlap="false"
                        matBadgePosition="above after"
                        class="number-icon"
                        [matBadge]="client_count"
                      ></mat-badge>
                    </mat-icon>
                    <span style="margin-left: 15px">Clientes</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list role="list" class="mat-list-item-nodes">
                  <mat-list-item
                    role="listitem"
                    *ngFor="let node of clientes"
                    class="node"
                  >
                    <mat-checkbox
                      class="example-margin"
                      [(ngModel)]="node.checked"
                      (ngModelChange)="changeNodeCheck(node)"
                      [labelPosition]="'after'"
                      color="primary"
                    >
                      {{ node.titulo }}
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                </mat-list>
              </mat-expansion-panel>

              <mat-expansion-panel hideToggle *ngIf="truecaller_count !== 0">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon
                      >person
                      <mat-badge
                        matBadgeOverlap="false"
                        matBadgePosition="above after"
                        class="number-icon"
                        [matBadge]="truecaller_count"
                      ></mat-badge>
                    </mat-icon>
                    <span style="margin-left: 15px">Truecaller</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list role="list" class="mat-list-item-nodes">
                  <mat-list-item
                    role="listitem"
                    *ngFor="let node of truecaller"
                    class="node"
                  >
                    <mat-checkbox
                      class="example-margin"
                      [(ngModel)]="node.checked"
                      (ngModelChange)="changeNodeCheck(node)"
                      [labelPosition]="'after'"
                      color="primary"
                    >
                      {{ node.titulo }}
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                </mat-list>
              </mat-expansion-panel>

              <mat-expansion-panel hideToggle *ngIf="account_count !== 0">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon
                      >account_balance
                      <mat-badge
                        matBadgeOverlap="false"
                        matBadgePosition="above after"
                        class="number-icon"
                        [matBadge]="account_count"
                      ></mat-badge>
                    </mat-icon>
                    <span style="margin-left: 15px">Cuentas</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list role="list" class="mat-list-item-nodes">
                  <mat-list-item
                    role="listitem"
                    *ngFor="let node of cuentas"
                    class="node"
                  >
                    <mat-checkbox
                      class="example-margin"
                      [(ngModel)]="node.checked"
                      (ngModelChange)="changeNodeCheck(node)"
                      [labelPosition]="'after'"
                      color="primary"
                    >
                      {{ node.titulo }}
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                </mat-list>
              </mat-expansion-panel>
              <mat-expansion-panel hideToggle *ngIf="cases_count !== 0">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon
                      >cases
                      <mat-badge
                        matBadgeOverlap="false"
                        matBadgePosition="above after"
                        class="number-icon"
                        [matBadge]="cases_count"
                      ></mat-badge>
                    </mat-icon>
                    <span style="margin-left: 15px">Casos</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list role="list" class="mat-list-item-nodes">
                  <mat-list-item
                    role="listitem"
                    *ngFor="let node of casos"
                    class="node"
                  >
                    <mat-checkbox
                      class="example-margin"
                      [(ngModel)]="node.checked"
                      (ngModelChange)="changeNodeCheck(node)"
                      [labelPosition]="'after'"
                      color="primary"
                    >
                      {{ node.titulo }}
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                  </mat-list-item>
                </mat-list>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-tab>
        <mat-tab label="Configuración"> </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <button
    mat-icon-button
    (click)="toggleDrawer()"
    class="toggle-drawer"
    *ngIf="!showConsulta"
  >
    <mat-icon>fullscreen</mat-icon>
  </button>
  <button
    mat-icon-button
    (click)="open3DGraph()"
    class="toggle-3d"
    *ngIf="!showConsulta"
  >
    <mat-icon>3d_rotation</mat-icon>
  </button>
  <div id="vis-chart" #vis class="col demo-chart"></div>

  <!-- standard material menu -->
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <ng-container *ngIf="node_type == undefined">
        <button mat-menu-item (click)="search('CustomerByAccount')">
          Rerender
        </button>
        <button mat-menu-item (click)="search('CustomerByAccount')">
          Reinit
        </button>
      </ng-container>

      <ng-container *ngIf="node_type == 'Account'">
        <button mat-menu-item (click)="search('CustomerByAccount')">
          Buscar cliente de esta cuenta
        </button>
        <button mat-menu-item (click)="search('TransfersByAccount')">
          Buscar transferencias de esta cuenta
        </button>
      </ng-container>

      <ng-container *ngIf="node_type == 'Customer'">
        <button mat-menu-item (click)="search('AccountsByCustomer')">
          Buscar cuentas de este cliente
        </button>
        <button mat-menu-item (click)="search('match_cases_of_customer')">
          Buscar casos de este cliente
        </button>
        <button
          mat-menu-item
          (click)="search('AccountsAndTransfersByCustomer')"
        >
          Buscar cuentas y transferencias de este cliente
        </button>
        <button
          mat-menu-item
          (click)="search('match_2best_transfers_by_account_by_CI')"
        >
          Buscar las top 2 transferencias.
        </button>
        <button mat-menu-item (click)="openDetail()">Ver detalle</button>
        <button mat-menu-item (click)="socialLinkSearch()">
          Busqueda Social Link Apis
        </button>
      </ng-container>

      <ng-container *ngIf="node_type == 'case'">
        <button mat-menu-item (click)="search('AN_case_search_users')">
          Buscar usuarios relacionados
        </button>
        <button mat-menu-item (click)="search('AN_case_search_case_type')">
          Buscar tipo de caso
        </button>
        <button mat-menu-item (click)="search('match_customer_of_case')">
          Buscar persona relacionada
        </button>
        <button mat-menu-item (click)="goToCase()">Ir al Caso</button>
      </ng-container>
      <ng-container
        *ngIf="
          node_type != 'case' &&
          node_type != 'Account' &&
          node_type != 'Customer'
        "
      >
        <button mat-menu-item (click)="openDetailSLNode()">
          Mostrar detalle
        </button>
      </ng-container>
    </ng-template>
  </mat-menu>
</div>
